import React from 'react';
import ReactDOM from 'react-dom';
import MainView from 'components/application/MainView';
import TestWizard from 'components/application/TestWizard';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('content');
  const data = JSON.parse(node.getAttribute('data'));

  let AudiotrainerMainView = React.createElement(MainView, {
    initialViewType: TestWizard,
    initialViewData: data
  });
  ReactDOM.render(AudiotrainerMainView, node);
});




// WEBPACK FOOTER //
// ./app/javascript/packs/test.js